"use client"

import type { Product } from "@/lib/types"
import { ProductCard } from "./product-card"
import Link from "next/link"
import { ChevronRight } from "lucide-react"

interface ProductSectionProps {
  title: string
  products: Product[]
  icon?: string
  sectionType?: string // Pour le lien "Voir plus"
}

export function ProductSection({ title, products, icon, sectionType }: ProductSectionProps) {
  if (products.length === 0) return null

  return (
    <section className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {icon && <span className="text-2xl">{icon}</span>}
          <h2 className="text-2xl font-bold text-foreground dark:text-dark-foreground">{title}</h2>
        </div>

        {sectionType && (
          <Link
            href={`/produits/sections/${sectionType}`}
            className="inline-flex items-center gap-1 text-primary hover:text-primary-dark transition-colors group"
          >
            <span className="font-medium">Voir plus</span>
            <ChevronRight
              size={20}
              className="transition-transform group-hover:translate-x-1"
            />
          </Link>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  )
}
